import * as React from "react"
import {AnalyticsThemeProvider} from "@app";

import overrideComponents from "./overrides";
import {scrapeMatcherPalette} from "./palette";

export default function AppTheme({ children }) {
    return <AnalyticsThemeProvider overrides={overrideComponents} palette={scrapeMatcherPalette}>
        {children}
    </AnalyticsThemeProvider>
}

